import Model, { attr } from '@ember-data/model';

export interface JournalGroupSaveUser {
  id: string;
  is_owner: boolean;
}

export default class JournalGroupModel extends Model {
  @attr('string') name!: string;
  @attr('date') createdAt?: Date;
  @attr() journalIds?: string[]; // only used for saving. is not returned from the server
  @attr() users?: JournalGroupSaveUser[]; // only used for saving. is not returned from the server
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'all-funds/journal-group': JournalGroupModel;
  }
}
